<template>
  <van-skeleton title title-width="100%" :row="0" id="skeleton-footer" :loading="sloading">
    <van-row id="footer2" class="footer2">
      <van-divider />
      <van-col span="18">
        {{site.title}}<br>
        地址：{{site.contact_address}}<br>
        招生热线：{{site.contact_tel}}<br>
        {{site.icp}}<br>
        {{site.copyright}}
      </van-col>
      <van-col span="6">
        <van-image
          width="90"
          height="90"
          :src="site.qrcodeUrl"
        />
      </van-col>

    </van-row>
  </van-skeleton>
</template>

<script>
const axios = require('axios')
import { Divider } from 'vant';

export default {
  name: 'footer2',
  data () {
    return {
      site: [{}],
      sloading: true
    }
  },
  mounted () {
    let that = this
    // 获取站点信息
    axios.get(that.global.apiUrl + '/web/site/queryAll')
      .then(function (response) {
        if (response.data.success && response.data.data.length > 0) {
          that.site = response.data.data[0]
          // that.site.logoUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + that.site.logo
          that.site.qrcodeUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + that.site.qrcode

          that.sloading = false
        }
      })
  },
}
</script>

<style>
.footer2 {
  background-color: #FFFFFF;
  padding: 1rem;
  text-align: left;
  color: #333333;
  font-size: 0.4rem;
  line-height: 1.2rem;
  margin-top: auto;
}
</style>



// WEBPACK FOOTER //
// src/view/footer/footer2.vue